import { environment } from '../../environments/environment';

export class WebServices {
  static CodigoSistema = '7';
  static IdSistema = '7';

  //STAGE
  static UrlBase = environment.webServices.SistemaProyectos; //"https://projectvestaapi-stg.azurewebsites.net/api/";
  static UrlFileShareWeb = environment.web.FileShare; //"https://fileshareweb-stage.azurewebsites.net/";
  static UrlFileShareApi = environment.webServices.FileShareApi; //"https://filesharewebapi-stage.azurewebsites.net/";
  static UrlProyectoWeb = environment.urlWebNueva.URL;
  /* static UrlProyectoWeb = 'https://solicituddeproyectos.vesta-accelerate.com/';*/
  //static UrlProyectoWeb = "https://scesolicituddeproyectosweb.vestadev-accelerate.com/"

  //PROD vesta-accelerate
  //static UrlBase = "https://projectvestaapi.vesta-accelerate.com/api/";
  //static UrlFileShareWeb = "https://fileshare.vesta-accelerate.com/";
  //static UrlFileShareApi = "https://fileshareapi.vesta-accelerate.com/";

  //Fileshare sin usar
  //static UrlFileShareWeb = "http://fileshare.grupovesta.com/";
  //static UrlFileShareApi = "http://filesharewebapi.grupovesta.com/";

  static UploadDocumentBlob = `${WebServices.UrlFileShareApi}api/SyncFolderFilesApi/PostSaveDocument`;
  static DownloadDocument = `${WebServices.UrlFileShareWeb}Default.aspx?pagina=FileShareDloadClienteSide&datos=`;
  static UploadDocuments = `${WebServices.UrlFileShareApi}Api/SyncFolderFilesApi/PostDataRequest=`;
  static UploadDocument = `${WebServices.UrlFileShareApi}Api/SyncFolderFilesApi/PostDataRequest`;
  static UploadClient = `${WebServices.UrlFileShareWeb}Default.aspx?pagina=FileShareUploadClientSide&datos=`;
  static GetFolderUrlSinged = `${WebServices.UrlFileShareApi}Api/SyncFolderFilesApi/GetFolderUrlSinged`;
  static GetResponseFileShare = `${WebServices.UrlFileShareApi}Api/SyncFolderFilesApi/GetResponseFileShare?id=`;
  static GetUrlFolderFileDownload = `${WebServices.UrlFileShareApi}api/SyncFolderFilesApi/GetUrlFolderFileDownload`;

  static GetClientes = `${WebServices.UrlBase}Personas/GetClientes`;
  static GetProveedorByPersonaJuridicaCliente = `${WebServices.UrlBase}Personas/GetProveedorByPersonaJuridicaCliente`;
  static GetGruposPersonas = `${WebServices.UrlBase}Personas/GetGruposPersonas`;
  static GetTiposObjetivos = `${WebServices.UrlBase}TipoObjetivo/Index`;
  static GetTipoObjetivoByCLaseProyectoId = `${WebServices.UrlBase}TipoObjetivo/GetTipoObjetivoByCLaseProyectoId`;
  static GetObjetivosEstrategicos = `${WebServices.UrlBase}ObjetivosEstrategico/Index`;
  static GetRutasByProyectoId = `${WebServices.UrlBase}TipoObjetivo/GetRutasByProyectoId`;

  static GetProyectosPorResponsable = `${WebServices.UrlBase}Project/GetProyectoByResponsable`;
  static GetProyectoPorCorrelativo = `${WebServices.UrlBase}Project/GetProyectoPorCorrelativo`;
  static CrearNuevoProyecto = `${WebServices.UrlBase}Project/CrearNuevoProyecto`;
  static EditarProyecto = `${WebServices.UrlBase}Project/EditarProyecto`;
  static CerrarProyecto = `${WebServices.UrlBase}Project/CerrarProyecto`;
  static GetFichaCierre = `${WebServices.UrlBase}Project/GetFichaCierreV2`;
  static GetProyectosFinalizados = `${WebServices.UrlBase}Project/GetProyectosFinalizadosV2`;
  static CambiarLiderProyecto = `${WebServices.UrlBase}Project/CambiarLiderProyecto`;
  //static AprobarProyecto = WebServices.UrlBase + "Project/AprobarProyecto";

  static GetObjetivosPorProyecto =
    WebServices.UrlBase + 'Objetivos/GetObjetivosPorProyecto';
  static CrearObjetivoPorProyecto = `${WebServices.UrlBase}Objetivos/CrearObjetivoPorProyecto`;
  static EditarObjetivoPorProyecto = `${WebServices.UrlBase}Objetivos/EditarObjetivoPorProyecto`;
  static EliminarObjetivoPorProyecto = `${WebServices.UrlBase}Objetivos/EliminarObjetivoPorProyecto`;

  static GetBeneficiosPorProyecto = `${WebServices.UrlBase}Beneficios/GetBeneficiosPorProyecto`;
  static CrearBeneficioPorProyecto = `${WebServices.UrlBase}Beneficios/CrearBeneficioPorProyecto`;
  static EditarBeneficioPorProyecto = `${WebServices.UrlBase}Beneficios/EditarBeneficioPorProyecto`;
  static EliminarBeneficioPorProyecto = `${WebServices.UrlBase}Beneficios/EliminarBeneficioPorProyecto`;

  static GetTipoArchivo = `${WebServices.UrlBase}Enum/GetTipoArchivo`;
  static GetLineas = `${WebServices.UrlBase}Enum/GetLineas`;
  static GetAreas = `${WebServices.UrlBase}Enum/GetAreas`;
  static GetTipoEmpresa = `${WebServices.UrlBase}Enum/GetTipoEmpresa`;
  static GetTipoClientes = `${WebServices.UrlBase}Enum/GetTipoClientes`;

  static ArchivosSubidosPorProyecto = `${WebServices.UrlBase}ArchivoSubido/ArchivosSubidosPorProyecto`;
  static SubirArchivo = `${WebServices.UrlBase}ArchivoSubido/SubirArchivo`;
  static DeshabilitarArchivoSubido = `${WebServices.UrlBase}ArchivoSubido/DeshabilitarArchivoSubido`;

  static GetTiempoProcesoPorProyecto = `${WebServices.UrlBase}TiempoProceso/GetTiempoProcesoPorProyecto`;
  static CrearTiempoProceso = `${WebServices.UrlBase}TiempoProceso/CrearTiempoProceso`;
  static EditarTiempoProceso = `${WebServices.UrlBase}TiempoProceso/EditarTiempoProceso`;
  static EliminarTiempoProceso = `${WebServices.UrlBase}TiempoProceso/EliminarTiempoProceso`;

  static GetResponsabilidadMantenimientoPorProyecto = `${WebServices.UrlBase}ResponsabilidadMantenimiento/GetResponsabilidadMantenimientoPorProyecto`;
  static CrearResponsablidadMantenimientos = `${WebServices.UrlBase}ResponsabilidadMantenimiento/CrearResponsablidadMantenimientos`;
  static EditarResponsabilidadMantenimiento = `${WebServices.UrlBase}ResponsabilidadMantenimiento/EditarResponsabilidadMantenimiento`;
  static EliminarResponsabilidadMantenimiento = `${WebServices.UrlBase}ResponsabilidadMantenimiento/EliminarResponsabilidadMantenimiento`;

  static GetTiempoRespuestaRequerimientoPorProyecto = `${WebServices.UrlBase}TiempoRespuestaRequerimiento/GetTiempoRespuestaRequerimientoPorProyecto`;
  static CrearTiempoRespuestaRequerimiento = `${WebServices.UrlBase}TiempoRespuestaRequerimiento/CrearTiempoRespuestaRequerimiento`;
  static EditarTiempoRespuestaRequerimiento = `${WebServices.UrlBase}TiempoRespuestaRequerimiento/EditarTiempoRespuestaRequerimiento`;
  static EliminarTiempoRespuestaRequerimiento = `${WebServices.UrlBase}TiempoRespuestaRequerimiento/EliminarTiempoRespuestaRequerimiento`;

  static GetMatrizEscalarPorProyecto = `${WebServices.UrlBase}Matrizescalar/GetMatrizEscalarPorProyecto`;
  static CrearMatrizEscalarSolicitud = `${WebServices.UrlBase}Matrizescalar/CrearMatrizEscalarSolicitud`;
  static EditarMatrizEscalar = `${WebServices.UrlBase}Matrizescalar/EditarMatrizEscalar`;
  static EliminarMatrizEscalar = `${WebServices.UrlBase}Matrizescalar/EliminarMatrizEscalar`;

  static GetBitacoraIncidentesPorProyecto = `${WebServices.UrlBase}BitacoraIncidentes/GetBitacoraIncidentesPorProyecto`;
  static CrearBitacoraIncidente = `${WebServices.UrlBase}BitacoraIncidentes/CrearBitacoraIncidente`;
  static EditarBitacoraIncidente = `${WebServices.UrlBase}BitacoraIncidentes/EditarBitacoraIncidente`;
  static EliminarBitacoraIncidente = `${WebServices.UrlBase}BitacoraIncidentes/EliminarBitacoraIncidente`;

  static GetActividadesPorProyetoAgrupadoPorCategoria = `${WebServices.UrlBase}Actividad/GetActividadesPorProyetoAgrupadoPorCategoria`;
  static ActividadesByProyectoByCategoriasV2ByEstadoActividad = `${WebServices.UrlBase}Actividad/ActividadesByProyectoByCategoriasV2ByEstadoActividad`;
  static CrearActividad = `${WebServices.UrlBase}Actividad/CrearActividad`;
  static EditarActividades = `${WebServices.UrlBase}Actividad/EditarActividades`;
  static EliminarActividades = `${WebServices.UrlBase}Actividad/EliminarActividades`;
  static ProrateoActividadesProyectoById = `${WebServices.UrlBase}Actividad/ProrateoActividadesProyectoById`;
  static ActividadesActivasByProyecto = `${WebServices.UrlBase}Actividad/ActividadesActivasByProyecto`;
  static GetActividadesSucesoras = `${WebServices.UrlBase}Actividad/GetActividadesSucesoras`;

  ///DependenciaActividades
  static CreateDependenciaActividades = `${WebServices.UrlBase}DependenciaActividades/CreateDependenciaActividades`;

  //Categorias
  static GetCategorias = `${WebServices.UrlBase}Categoria/GetCategorias`;
  static GetCategoriasPorUsuario = `${WebServices.UrlBase}Categoria/GetCategoriasPorUsuario`;
  static GetCategoriaByClaseProyecto = `${WebServices.UrlBase}Categoria/GetCategoriaByClaseProyecto`;
  static CrearNuevaCategoria = `${WebServices.UrlBase}Categoria/CrearNuevaCategoria`;
  static UpdateCategoria = `${WebServices.UrlBase}Categoria/UpdateCategoria`;
  static DeleteCategoria = `${WebServices.UrlBase}Categoria/DeleteCategoria`;

  static CrearResponsablesListaPorActividad = `${WebServices.UrlBase}ResponsableActividad/CrearResponsablesListaPorActividad`;
  static CrearResponsableIndividualPorActividad = `${WebServices.UrlBase}ResponsableActividad/CrearResponsableIndividualPorActividad`;
  static ActualizarResponsablesListaPorActividad = `${WebServices.UrlBase}ResponsableActividad/ActualizarResponsablesListaPorActividad`;
  static AsignacionPreVista = `${WebServices.UrlBase}ResponsableActividad/AsignacionPrevista`;
  static AsignacionVista = `${WebServices.UrlBase}ResponsableActividad/AsignacionVista`;

  static EnviarPdfDocumento = `${WebServices.UrlBase}Documentos/EnviarPdfDocumento`;
  static CambiarEstadoPdfDocumento = `${WebServices.UrlBase}Documentos/CambiarEstadoPdfDocumento`;
  static EliminarPdfDocumento = `${WebServices.UrlBase}Documentos/EliminarPdfDocumento`;
  static ObtenerUsuariosConCertificado = `${WebServices.UrlBase}Documentos/ObtenerUsuariosConCertificado`;
  static UrlDownloadDocumentFileshare = `${WebServices.UrlBase}FileShare/PostUrlFolderFileDownload`;
  static MergePdfDocuments = `${WebServices.UrlBase}FileShare/UnirArchivosPdf`;
  static VerificarAnexos = `${WebServices.UrlBase}FileShare/VerificarAnexos`;

  //Módulo cartera de proyectos
  static Cronograma = `${WebServices.UrlBase}Project/Cronograma`;
  static ProyectoByLider = `${WebServices.UrlBase}Project/ProyectoByLider`;
  static ProyectosByRolByPersonaId = `${WebServices.UrlBase}Project/ProyectosByRolByPersonaIdV2`;
  static ListaActividadesPorResponsable = `${WebServices.UrlBase}Actividad/ListaActividadesPorResponsable`;
  static UpdateProcesoActividadById = `${WebServices.UrlBase}Actividad/UpdateProcesoActividadById`;
  static GetRolesByValues = `${WebServices.UrlBase}RolRelacion/GetRolesByValues`;
  static GetRolesByPersonaId = `${WebServices.UrlBase}RolRelacion/GetRolesByPersonaId`;
  static GetRolesByListValues = `${WebServices.UrlBase}RolRelacion/GetRolesByListValues`;

  static DetailsProjectsPersonaId = `${WebServices.UrlBase}ResponsableProyecto/DetailsByPersonaId`;
  static EliminarSupervisor = `${WebServices.UrlBase}ResponsableProyecto/Delete`;
  static AgregarSupervisores = `${WebServices.UrlBase}ResponsableProyecto/Create`;

  //Modulo de impacto
  static CrearImpacto = `${WebServices.UrlBase}Impacto/Create`;
  static CreateImpactoDetalle = `${WebServices.UrlBase}Impacto/CreateImpactoDetalle`;
  static UpdateImpacto = `${WebServices.UrlBase}Impacto/Update`;
  static DeleteImpacto = `${WebServices.UrlBase}Impacto/Delete`;
  static CreateList = `${WebServices.UrlBase}Impacto/CreateList`;
  static DetailsByResultadoClave = `${WebServices.UrlBase}Impacto/DetailsByResultadoClave/`;
  static DetailsByImpactoMeta = `${WebServices.UrlBase}Impacto/DetailsByImpactoMeta`;
  static UpdateValorImpacto = `${WebServices.UrlBase}Impacto/UpdateValor`;
  static UltimoValorImpacto = `${WebServices.UrlBase}Impacto/UltimoValor`;
  static GetDetallesImpactoByImpactoId = `${WebServices.UrlBase}Impacto/GetDetallesImpactoByImpactoId`;
  static AgregarDocumentoImpactoDetalle = `${WebServices.UrlBase}Impacto/AgregarDocumentoImpactoDetalle`;
  static EnProcesoImpactoDetalle = `${WebServices.UrlBase}Impacto/EnProcesoImpactoDetalle`;
  static FinalizadoImpactoDetalle = `${WebServices.UrlBase}Impacto/FinalizadoImpactoDetalle`;
  static UpdateImpactoDetalle = `${WebServices.UrlBase}Impacto/UpdateImpactoDetalle`;
  static DeleteImpactoDetalle = `${WebServices.UrlBase}Impacto/DeleteImpactoDetalle`;
  static DeleteDocumentoImpactoDetalle = `${WebServices.UrlBase}Impacto/DeleteDocumentoImpactoDetalle`;
  static UpdateResposanbleExito = `${WebServices.UrlBase}Impacto/UpdateResposanbleExito`;
  static CreateImpactoDetalleUnico = `${WebServices.UrlBase}Impacto/CreateImpactoDetalleUnico`;
  static DeleteImpactoDetalleUnico = `${WebServices.UrlBase}Impacto/DeleteImpactoDetalleUnico`;

  //Modulo de objetivo strategico
  static CreateListResultados = `${WebServices.UrlBase}ObjetivosEstrategico/CreateListResultados`;
  static DetailsBySponsor = `${WebServices.UrlBase}ObjetivosEstrategico/DetailsBySponsor`;
  static DetailsBySponsorByPersonaId = `${WebServices.UrlBase}ObjetivosEstrategico/DetailsBySponsorByPersonaId`;
  static UpdateObjetivosEstrategico = `${WebServices.UrlBase}ObjetivosEstrategico/Update`;
  static DeleteByResultadoClave = `${WebServices.UrlBase}ObjetivosEstrategico/DeleteByResultadoClave`;
  static DeleteBySponsor = `${WebServices.UrlBase}ObjetivosEstrategico/DeleteBySponsor`;
  static DeleteByValidacion = `${WebServices.UrlBase}ObjetivosEstrategico/DeleteByValidacion`;

  //Modulo de proyectos
  static GetProyectosByPersona = `${WebServices.UrlBase}Project/ProyectoBySponsor?PersonaId=`;
  static GetResponsablesByProyectos = `${WebServices.UrlBase}ResponsableProyecto/DetailsByProyectos?`;

  //Sponsor
  static GetSponsors = `${WebServices.UrlBase}Sponsor/Index`;

  //SponsorObjetivoEstrategico
  static SponsorObjetivoCreateList = `${WebServices.UrlBase}SponsorObjetivoEstrategico/CreateList`;

  //ResultadoClave
  static DetailsByObjetivoestrategicoId = `${WebServices.UrlBase}ResultadosClave/DetailsByObjetivoestrategicoId`;
  static ResultadoClaveCreateList = `${WebServices.UrlBase}ResultadosClave/CreateList`;
  static IndexResultadoClave = `${WebServices.UrlBase}ResultadosClave/Index`;
  static UpdateValorResultadoClave = `${WebServices.UrlBase}ResultadosClave/UpdateValor`;
  static DetailsByIdResultadoClave = `${WebServices.UrlBase}ResultadosClave/DetailsById`;

  //Enums
  static GetMedidas = `${WebServices.UrlBase}Enum/GetMedidas`;
  static GetEstadoObjetivo = `${WebServices.UrlBase}Enum/GetEstadoObjetivo`;

  //NOTAS
  static CreateNotaPrincipalProyecto = `${WebServices.UrlBase}Nota/CreateNotaPrincipalProyecto`;
  static CreateNotaPrincipalObjetivoGeneral = `${WebServices.UrlBase}Nota/CreateNotaPrincipalObjetivoGeneral`;
  static CreateNotaPrincipalImpacto = `${WebServices.UrlBase}Nota/CreateNotaPrincipalImpacto`;
  static CreateNotaPrincipalOportunidad = `${WebServices.UrlBase}Nota/CreateNotaPrincipalOportunidad`;
  static CreateNotaPrincipalActividad = `${WebServices.UrlBase}Nota/CreateNotaPrincipalActividad`;
  static CreateNotaReplica = `${WebServices.UrlBase}Nota/CreateNotaReplica`;
  static CreateNotaReplicaReplica = `${WebServices.UrlBase}Nota/CreateNotaReplicaReplica`;
  static DeleteNota = `${WebServices.UrlBase}Nota/Delete`;
  static NotaRelevante = `${WebServices.UrlBase}Nota/NotaRelevante`;
  static DetailsByObjetivo = `${WebServices.UrlBase}Nota/DetailsByObjetivo`;
  static DetailsByProyecto = `${WebServices.UrlBase}Nota/DetailsAllNotasByProyecto`;
  static UpdateFileshareId = `${WebServices.UrlBase}Nota/UpdateFileshareId`;

  //ACTIVIDADES
  static UpdateFechaFinHito = `${WebServices.UrlBase}Actividad/UpdateFechaFinHito`;
  static TiemposByActividades = `${WebServices.UrlBase}Actividad/TiemposByActividades`;
  static UpdateProcentaje = `${WebServices.UrlBase}Actividad/UpdateProcentaje`;
  static ActividadesByResponsableBySemana = `${WebServices.UrlBase}Actividad/ActividadesByResponsableBySemanaByMesesV2`;
  static ActividadesById = `${WebServices.UrlBase}Actividad/ActividadesById`;
  static UpdateFechaByList = `${WebServices.UrlBase}Actividad/UpdateFechaByList`;
  static GetActividadesSinFinalizarByProyectos = `${WebServices.UrlBase}Actividad/GetActividadesSinFinalizarByProyectos`;

  //OPORTUNIDADRETO
  static CreateOportunidadReto = `${WebServices.UrlBase}OportunidadReto/Create`;
  static ConvertirOportunidadRetoAObjetivo = `${WebServices.UrlBase}OportunidadReto/ConvertirOportunidadRetoAObjetivo`;
  static AgreagrConsluison = `${WebServices.UrlBase}OportunidadReto/AgregarConclusion`;
  static DetailsByProyectoIdOportunidad = `${WebServices.UrlBase}OportunidadReto/DetailsByProyectoId`;
  static UpdateOportunidad = `${WebServices.UrlBase}OportunidadReto/Update`;
  static DeleteOportunidad = `${WebServices.UrlBase}OportunidadReto/Delete`;

  //CALENDARIOGENERALRESPONSABLE
  static CreateListCalendarioGeneral = `${WebServices.UrlBase}CalendarioGeneralResponsable/CreateList`;
  static UpdateCalendarioGeneral = `${WebServices.UrlBase}CalendarioGeneralResponsable/Update`;
  static DeleteCalendarioGeneral = `${WebServices.UrlBase}CalendarioGeneralResponsable/Delete`;
  static DetailsByResponsableCalendarioGeneral = `${WebServices.UrlBase}CalendarioGeneralResponsable/DetailsByResponsable`;

  //CALENDARIORESPONSABLE
  static CreateListCalendario = `${WebServices.UrlBase}CalendarioResponsable/CreateList`;
  static UpdateCalendario = `${WebServices.UrlBase}CalendarioResponsable/Update`;
  static DeleteCalendario = `${WebServices.UrlBase}CalendarioResponsable/Delete`;
  static GetResponsableByProyecto = `${WebServices.UrlBase}CalendarioResponsable/GetResponsableByProyecto`;
  static DetailsByProyectoByListResponsable = `${WebServices.UrlBase}CalendarioResponsable/DetailsByProyectoByListResponsable`;
  static DetailsByProyectoByListResponsableByNumeroMes = `${WebServices.UrlBase}CalendarioResponsable/DetailsByProyectoByListResponsableByNumeroMes`;

  //PERSONAS
  static GetContactosByClienteId = `${WebServices.UrlBase}Personas/GetContactosByClienteId`;
  static PersonaById = `${WebServices.UrlBase}Personas/PersonasById`;
  static GetGrupos = `${WebServices.UrlBase}Personas/GetGrupos`;

  //CONSUMO REPORTES
  static CreateReporte = `${WebServices.UrlBase}ConsumoReportes/Create`;

  //LogAvance
  static CreateLogAvanceProyecto = `${WebServices.UrlBase}LogAvance/CreateLogAvanceProyecto`;
  static CreateLogAvanceObjetivoPorProyecto = `${WebServices.UrlBase}LogAvance/CreateLogAvanceObjetivoPorProyecto`;

  //IMPACTOMETA
  static CreateImpactoMeta = `${WebServices.UrlBase}ImpactoMeta/Create`;
  static CreateImpactoMetaList = `${WebServices.UrlBase}ImpactoMeta/CreateList`;
  static UpdateImpactoMetaList = `${WebServices.UrlBase}ImpactoMeta/Update`;
  static DeleteImpactoMetaList = `${WebServices.UrlBase}ImpactoMeta/Delete`;
  static DetailsByResultadoClaveImpactoMetaList = `${WebServices.UrlBase}ImpactoMeta/DetailsBYResultadoClaveByProyecto`;
  static UpdateValorImpactoMeta = `${WebServices.UrlBase}ImpactoMeta/UpdateValor`;

  //SugerenciaFechas
  static SugerenciaFechas = `${WebServices.UrlBase}ResponsableActividad/SugerenciaFechas`;

  //PROYECTO

  static ProyectoEnPausaON = `${WebServices.UrlBase}Project/ProyectoEnPausaON`;
  static ProyectoEnPausaOFF = `${WebServices.UrlBase}Project/ProyectoEnPausaOFF`;

  //Moneda
  static GetMonedas = `${WebServices.UrlBase}CAPEX/GetMonedas`;

  //Tenant
  static GetTenant = `${WebServices.UrlBase}CAPEX/GetTenant`;

  //Material Tenant
  static GetMaterialTenantByTenantId = `${WebServices.UrlBase}CAPEX/GetMaterialTenantByTenantId`;
  static GetMaterialTenant = `${WebServices.UrlBase}CAPEX/GetMaterialTenant`;

  //CAPEXVM
  static CreateCapexVm = `${WebServices.UrlBase}CAPEX/Create`;
  static GetCapexByProyectoId = `${WebServices.UrlBase}CAPEX/DetailsProyectoId`;
  static UpdateCapex = `${WebServices.UrlBase}CAPEX/Update`;
  static DeleteCapex = `${WebServices.UrlBase}CAPEX/Delete`;
  static ChangeStateCapex = `${WebServices.UrlBase}CAPEX/CambiarTipoCapex`;

  //LogInformes
  static CreateLogInforme = `${WebServices.UrlBase}LogInformes/Create`;

  //BloqueoXGrupoPersona
  static GetBloqueoXGrupoPersona = `${WebServices.UrlBase}BloqueoXGrupoPersona/ValidarBloqueo`;

  //Desplegables
  static GetFlujos = `${WebServices.UrlBase}Desplegables/GetFlujos`;
  static GetFlujosByClienteByLinea = `${WebServices.UrlBase}Desplegables/GetFlujosByClienteByLinea`;
  static GetClaseProyecto = `${WebServices.UrlBase}Desplegables/GetClaseProyecto`;
  static GetTipoImpactoByTipoObjetivo = `${WebServices.UrlBase}Desplegables/GetTipoImpactoByTipoObjetivo`;
  static GetTipoHitooByTipoObjetivo = `${WebServices.UrlBase}Desplegables/GetTipoHitooByTipoObjetivo`;
  static GetJefeColaboradorByColaboradorId = `${WebServices.UrlBase}Desplegables/GetJefeColaboradorByColaboradorId`;
  static CreateColaboradorJefe = `${WebServices.UrlBase}Desplegables/CreateColaboradorJefe`;

  //Objetivos
  static CreateSitioSegmentoByList = `${WebServices.UrlBase}Objetivos/CreateSitioSegmentoByList`;
  static GetSitioSegmentoXObjetivo = `${WebServices.UrlBase}Objetivos/GetSitioSegmentoXObjetivo`;
  static DeleteSitioSegmento = `${WebServices.UrlBase}Objetivos/DeleteSitioSegmento`;

  //Mantenimiento
  static GetFlujosMantenimiento = `${WebServices.UrlBase}Desplegables/GetFlujos`;
  static CreateFlujoMantenimiento = `${WebServices.UrlBase}Desplegables/CreateFlujo`;
  static DeleteFlujoMantenimiento = `${WebServices.UrlBase}Desplegables/DeleteFlujo`;
  static GetClaseProyectoMantenimiento = `${WebServices.UrlBase}Desplegables/GetClaseProyecto`;
  static CreateClaseProyectoMantenimiento = `${WebServices.UrlBase}Desplegables/CreateClaseProyecto`;
  static GetClaseProyectoByIdByMantenimiento = `${WebServices.UrlBase}Desplegables/GetClaseProyectoById`;
  static DeleteClaseProyectoMantenimiento = `${WebServices.UrlBase}Desplegables/DeleteClaseProyecto`;
  static DeleteImpactoMantenimiento = `${WebServices.UrlBase}Desplegables/DeleteTipoImpacto`;
  static CreateTipoImpactoMantenimiento = `${WebServices.UrlBase}Desplegables/CreateTipoImpacto`;
  static CreateTipoHitoMantenimiento = `${WebServices.UrlBase}Desplegables/CreateTipoHito`;
  static DeleteTipoHitoMantenimiento = `${WebServices.UrlBase}Desplegables/DeleteTipoHitoo`;
  static GetTipoObjetivoMantenimiento = `${WebServices.UrlBase}TipoObjetivo/GetTipoObjetivoByCLaseProyectoId`;
  static CreateTipoObjetivoMantenimiento = `${WebServices.UrlBase}TipoObjetivo/Create`;
  static DeleteTipoObjetivoMantenimiento = `${WebServices.UrlBase}TipoObjetivo/Delete`;
  static CrearNuevaCategoriaMantenimiento = `${WebServices.UrlBase}Categoria/CrearNuevaCategoria`;
  static DeleteCategoriaMantenimiento = `${WebServices.UrlBase}Categoria/DeleteCategoria`;
  static GetCategoriasMantenimiento = `${WebServices.UrlBase}Categoria/GetCategorias`;
  static UpdateCategoriaMantenimiento = `${WebServices.UrlBase}Categoria/UpdateCategoria`;

  // HojaDeRuta
  static GetTipoDocumentos = `${WebServices.UrlBase}HojaDeRuta/GetTipoDocumentos`;
}
